import { PartnersPaymentSummary } from 'gql/generated/graphql'
import { createPaymentSummaryModel } from './models'
import { IPaymentSummaryModel } from './types'

export interface IPaymentsSummaryCollection {
  items: IPaymentSummaryModel[]
  isEmpty: boolean
}

export const createPaymentsSummaryCollection = (items: PartnersPaymentSummary[]): IPaymentsSummaryCollection => {
  return {
    items: items.map((item) => createPaymentSummaryModel(item)),
    isEmpty: items.length === 0
  }
}
